module.exports = __webpack_public_path__ + "media/images/pen-894d2f492aef254ea6fd22de5b2dbd28.svg";